/**
 * Meta Pixel — consent-gated loader.
 * -----------------------------------
 * Meta Pixel får INTE initieras eller skicka PageView/Lead innan användaren
 * har godkänt marknadsföringscookies i vår befintliga cookie-banner.
 *
 * Återanvänder EXAKT samma consent-logik som resten av sajten
 * (utils/cookieConsent.js) — inget parallellt samtyckessystem:
 *   - Redan godkänt marknadsföring tidigare  → pixeln laddas normalt vid
 *     sidladdning.
 *   - Inget marknadsföringssamtycke ännu      → ingen init, ingen PageView.
 *     Vi lyssnar på consent-ändringar och laddar pixeln FÖRST när användaren
 *     godkänner marknadsföring (i banner eller cookieinställningar).
 *
 * `window.fbq` existerar inte som funktion förrän marknadsföring godkänts, så
 * Lead-eventet i utils/nyHemsidaTracking.js (som är guardat med
 * `typeof window.fbq === 'function'`) kan aldrig skickas utan samtycke.
 */
import { getConsent, onConsentChange } from "@/utils/cookieConsent";
import { logMetaPageview } from "@/utils/nyHemsidaVisit";

const PIXEL_ID = "1077078338617283";
let loaded = false;

function loadPixel() {
  if (typeof window === "undefined") return;
  if (loaded || typeof window.fbq === "function") {
    loaded = true;
    return;
  }
  loaded = true;
  // Standard Meta Pixel base-kod (samma snippet som Meta tillhandahåller).
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  try {
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
    // Passiv diagnostik EFTER det befintliga PageView-anropet. Ändrar varken
    // gating eller exekveringsordning; loggar bara att PageView skickades.
    logMetaPageview();
  } catch {
    /* aldrig krascha sidan på tracking */
  }
}

export function initMetaPixel() {
  if (typeof window === "undefined") return;
  // Redan godkänt marknadsföring → ladda direkt vid sidladdning.
  try {
    if (getConsent().marketing) {
      loadPixel();
      return;
    }
  } catch {
    /* ignore */
  }
  // Annars: vänta på consent och ladda först när marknadsföring godkänns.
  onConsentChange((e) => {
    try {
      const marketing = e && e.detail ? !!e.detail.marketing : getConsent().marketing;
      if (marketing) loadPixel();
    } catch {
      /* ignore */
    }
  });
}

export const META_PIXEL_ID = PIXEL_ID;
